import apiClient from '../../shared/services/apiClient';

const API_BASE = '/api/admin';

/**
 * Coupon Service (Admin)
 *
 * 优惠码管理接口，全部走 /api/admin/coupons/* 前缀
 */
const couponService = {
    // 优惠码列表（分页 + 搜索）
    async getCoupons(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons`, { params });
        return response.data;
    },

    // 创建优惠码
    async createCoupon(data) {
        const response = await apiClient.post(`${API_BASE}/coupons/create`, data);
        return response.data;
    },

    // 更新优惠码
    async updateCoupon(data) {
        const response = await apiClient.post(`${API_BASE}/coupons/update`, data);
        return response.data;
    },

    // 删除优惠码（已有核销记录时后端会转为停用）
    async deleteCoupon(id) {
        const response = await apiClient.post(`${API_BASE}/coupons/delete`, { id });
        return response.data;
    },

    // 优惠码核销记录（分页）
    async getRedemptions(couponId, params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/redemptions`, {
            params: { coupon_id: couponId, ...params },
        });
        return response.data;
    },

    // 使用统计（按券：券包状态 / 核销 / 续费沿用 / 体验）
    async getStats(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/stats`, { params });
        return response.data;
    },

    // 已发的券（按用户 / 券 / 状态）
    async getIssued(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/issued`, { params });
        return response.data;
    },

    // 手动发券：{coupon_id, user_ids | filter, once_per_user, notify, note, dry_run}
    async issue(data) {
        const response = await apiClient.post(`${API_BASE}/coupons/issue`, data);
        return response.data;
    },

    // 收回未用的券
    async revoke(ids, note) {
        const response = await apiClient.post(`${API_BASE}/coupons/issued/revoke`, { ids, note });
        return response.data;
    },

    // 自动发券规则
    async getRules() {
        const response = await apiClient.get(`${API_BASE}/coupons/rules`);
        return response.data;
    },
    async saveRule(data) {
        const response = await apiClient.post(`${API_BASE}/coupons/rules/save`, data);
        return response.data;
    },
    // 规则/任务运行记录（job=rule&rule_id= | job=trials | job=wallet），新的在前
    async getRuleRuns(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/rules/runs`, { params });
        return response.data;
    },
    // 只读预览：下一个 tick 会发给谁
    async previewRule(id) {
        const response = await apiClient.get(`${API_BASE}/coupons/rules/preview`, { params: { id } });
        return response.data;
    },
    // 立即运行一次（与定时任务同一路径、同一去重）
    async runRule(id) {
        const response = await apiClient.post(`${API_BASE}/coupons/rules/run`, { id });
        return response.data;
    },

    // 节日活动：列表 / 未来节日 / 预设 / 保存 / 开启 / 停止 / 复制到某年 / 删除草稿 / 发券预览 / 立即发券
    async getCampaigns(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/campaigns`, { params });
        return response.data;
    },
    async getHolidays(months = 12) {
        const response = await apiClient.get(`${API_BASE}/coupons/campaigns/holidays`, { params: { months } });
        return response.data;
    },
    async getCampaignPreset(key, year) {
        const response = await apiClient.get(`${API_BASE}/coupons/campaigns/preset`, { params: { key, year } });
        return response.data;
    },
    async saveCampaign(data) {
        const response = await apiClient.post(`${API_BASE}/coupons/campaigns/save`, data);
        return response.data;
    },
    async campaignAction(action, id, extra = {}) { // start | stop | clone | delete | issue
        const response = await apiClient.post(`${API_BASE}/coupons/campaigns/${action}`, { id, ...extra });
        return response.data;
    },
    async previewCampaign(id) {
        const response = await apiClient.get(`${API_BASE}/coupons/campaigns/preview`, { params: { id } });
        return response.data;
    },

    // 0 元体验记录
    async getTrials(params = {}) {
        const response = await apiClient.get(`${API_BASE}/coupons/trials`, { params });
        return response.data;
    },

    // 产品列表（范围 / 体验套餐下拉）
    async getProducts() {
        const response = await apiClient.get(`${API_BASE}/products`);
        return response.data;
    },

    // 产品类型列表（用于 applies_to 下拉）
    async getProductTypes() {
        const response = await apiClient.get(`${API_BASE}/product-types`);
        return response.data;
    },
};

export default couponService;
